import React from 'react';

import config from '../config';

export const OneTrustScripts: React.FC = () => {
  if (config.USE_ONETRUST_COOKIE_BANNER !== 'true') {
    return null;
  }

  return (
    <>
      <script
        src="https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js"
        type="text/javascript"
        data-domain-script={config.ONETRUST_ID}
      />
      <script type="text/javascript">{`function OptanonWrapper() { }`}</script>
    </>
  );
};
